<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall" :initial-values="{isPartial: 0}" ref="myForm">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Transaction Id</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="transactionId"
                                  rules="required"
                                  :class="(errors.transactionId && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="transactionId"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Amount</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="amount"
                                  rules="required|decAmount"
                                  :class="(errors.amount && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="amount"/>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label></label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="">-->
<!--                              <div class="custom-control custom-control-primary custom-checkbox">-->
<!--                                <Field name="isPartial" type="checkbox" :value="1"-->
<!--                          class="custom-control-input" id="colorCheck1" />-->
<!--                                <label class="custom-control-label" for="colorCheck1">Partial</label>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-sm-9 offset-sm-3">
                        <Button class="btn btn-primary mr-1" :loading="loader">Create</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'refund-request' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {

  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Refund'},
        {name: 'Add'},
      ],
      loader: false,
      isPartial: '',
      transactionId:''

    }
  },
  methods: {
    sendCall(values) {
      // if (typeof (values.isPartial) == 'undefined') {
      //   values.isPartial = 0;
      // }
      let data = values
      data.amount = data.amount*100
      this.loader = true
      this.makeRequest('post', 'v1/create-refund-request', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'refund-request'});
          }
          this.$refs.myForm.setFieldValue('amount', '')
        }
        this.$refs.myForm.setFieldValue('amount', '')

      });

    },
  },
}
</script>

